document.querySelectorAll('.inspiration-tiles').forEach((container) => {
	const inspirations = container.querySelectorAll('.inspiration-tile');

	// remove the show class on all elements
	inspirations.forEach((inspiration) => inspiration.classList.remove('show'));

	// add the show class on a random element
	inspirations[Math.floor(Math.random() * inspirations.length)].classList.add('show');
})
